import React, { useState, useEffect, Fragment } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { customersummaryreport, customersummarydetailreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { accountsLocations, getLocations, getMultipleSubAccountLocations } from '../../services/userservice';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/appSlice';
import ExportExcelButton from "../../components/exportExcelButton";

export const csrColumns = [
  { label: "Region", key: "Region" },
  { label: "Zone", key: "Zone" },
  { label: "Branch", key: "Branch" },
  { label: "Customer Name", key: "CustomerName" },
  { label: "Account No", key: "AccountNo" },
  { label: "Location Name", key: "LocationName" },
  { label: "Total Booked", key: "TotalBooked" },
  { label: "Booked", key: "Booked" },
  { label: "Void", key: "Void" },
  { label: "Loadsheet", key: "Loadsheet" },
  { label: "Received at OPS", key: "RecievedatOPS" },
  { label: "Delivered", key: "Delivered" },
  { label: "RTS", key: "RTS" },
  { label: "Undelivered", key: "Undelivered" },
];


export const csrDetailColumns = [
  { label: "Consignment Number", key: "consignmentNumber" },
  { label: "Customer Name", key: "CustomerName" },
  { label: "Account No", key: "AccountNo" },
  { label: "Location Name", key: "LocationName" },
  { label: "Consignee", key: "consignee" },
  { label: "Booking Date", key: "BookingDate" },
  { label: "Origin Zone", key: "OriginZone" },
  { label: "Origin Branch", key: "OriginBranch" },
  { label: "Destination Zone", key: "DestZone" },
  { label: "Destination Branch", key: "DestBranch" },
  { label: "Pieces", key: "pieces" },
  { label: "Weight", key: "weight" },
  { label: "COD Amount", key: "codAmount", formatter: v => Number(v || 0).toFixed(2) },
  { label: "Order Ref No", key: "orderRefNo" },
  { label: "VOID", key: "VOID" },
  { label: "Loadsheet", key: "Loadsheet" },
  { label: "Received", key: "Received" },
  { label: "Delivered", key: "Delivered" },
  { label: "RTS", key: "RTS" },
  { label: "Undelivered", key: "Undelivered" },
  { label: "Remarks", key: "Remarks" },
  { label: "Product Description", key: "productDescription" },
];


const CustomerSummary = () => {
    const dispatch = useDispatch();
    const { accounts, subaccounts, loading, userInfo } = useSelector(state => state.appData);
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const month = `${now.getMonth() + 1}`;
    const year = `${now.getFullYear()}`;

    const history = useHistory();
    const d = {
        isMonthWise: false,
        StartDate: today,
        EndDate: today,
        Year: year,
        Month: month,
        locationID: [],
        account: [accounts[0]],
        creditclientid: '',
        subAccountId: []
    };

    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [detailGrid, setDetailGrid] = useState([]);
    const [locations, setLocations] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);

    useEffect(() => {
        if (!valdiatePage('/customersummary')) {
            history.push('/login');
        }
        // if (data.account) {
        //     getLocations(userInfo.id, data.account).then(locs => {
        //         if (locs) {
        //             setLocations(locs);
        //             setData({ ...data, account: data.account, locationID: locs.map(v => v.value).join(), creditclientid: locs.map(v => v.creditClientId).join() });
        //         }
        //     })
        // }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {
        setDetailGrid([]);
        if (data.isMonthWise) {
            if (!data.Year) {
                alert('Select Year');
                return;
            }
            if (!data.Month) {
                alert('Select Month');
                return;
            }
        }
        else {
            if (!data.StartDate) {
                alert('Select Start Date');
                return;
            }
            if (!data.EndDate) {
                alert('Select End Date');
                return;
            }
        }

        if (!data.account || data.account.length == 0) {
            alert('Select Account');
            return;
        }
        if (!data.locationID || data.locationID.length == 0) {
            alert('Select Location');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await customersummaryreport(data);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                //console.log(rs.data);
                setGrid(rs.data);
            }
            else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
        }
    }

    const SearchDetail = async (reporttype, accountno, locationID) => {
        if (data.isMonthWise) {
            if (!data.Year) {
                alert('Select Year');
                return;
            }
            if (!data.Month) {
                alert('Select Month');
                return;
            }
        }
        else {
            if (!data.StartDate) {
                alert('Select Start Date');
                return;
            }
            if (!data.EndDate) {
                alert('Select End Date');
                return;
            }
        }

        if (!accountno) {
            alert('Select Account');
            return;
        }
        if (!locationID) {
            alert('Select Location');
            return;
        }

        const detail = {
            isMonthWise: data.isMonthWise,
            StartDate: data.StartDate,
            EndDate: data.EndDate,
            Year: data.Year,
            Month: data.Month,
            locationID: locationID.toString(),
            account: accountno,
            creditclientid: '',
            reporttype: reporttype
        }

        dispatch(setLoading({ data: true }));

        var rs = await customersummarydetailreport(detail);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                console.log(rs.data);
                setDetailGrid(rs.data);
            }
            else {
                alert('No Data Found');
                setDetailGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setDetailGrid([]);
        }
    }

    useEffect(async () => {
        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
            const d = { ...data, account: [accounts[0]], subAccountId: [subAccs[0].id]};

            if (locs.length > 0) {
                d.locationID = [+locs[0].value]
                setLocations(locs);
            }
            setData(d);

        }
    }, [])

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Customer Summary</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row pb-2">
                <div className="col">
                    <label>Account</label>
                    <select className="form-select" multiple value={data.account} onChange={async (e) => {
                        let value = Array.from(e.target.selectedOptions, option => option.value);
                        let d = { ...data, account: value };
                        if (value && value.length > 0) {
                            const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                            setSubAccountsLocal(subAccs);
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                            d.subAccountId =  [subAccs[0].id];
                
                            if (locs.length > 0) {
                                d.locationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                        }
                        setData(d);
                    }}>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>

                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                        const selectedOptions = Array.from(e.target.selectedOptions);

                        const accnos = selectedOptions
                            .map(option => option.getAttribute('data-accno'))
                            .filter(acc => acc && acc.trim() !== '');
                
                        const uniqueAccnos = Array.from(
                            new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                        );

                        const val = Array.from(new Set(
                            selectedOptions
                                .map(option => option.value)
                                .filter(v => v && !isNaN(v))
                                .map(v => parseInt(v))
                        ));


                        console.log("Filtered SubAccount IDs:", val);
                        console.log("Unique Account Nos (data-accno):", uniqueAccnos);

                        const d = { ...data, subAccountId: val, account: uniqueAccnos };
                        if (val) {
                            //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                            console.log(locs);
                            if (locs && locs.length > 0) {
                                
                                d.locationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                            //d.isCod = null;
                        }
                        setData({ ...d});
                    }}>
                        <option value="" data-accno="" data-iscod="">Select Sub Account</option>
                        {
                            subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>

                <div className="col">
                    <label>Location</label>
                    <select className="form-select" multiple value={data.locationID} onChange={async (e) => {
                        let val = Array.from(e.target.selectedOptions, option => +option.value);
                        setData({ ...data, locationID: val });
                    }}>
                        {
                            locations.length > 0 && locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row pb-2">
                <div className="col-2">
                    <label style={{ whiteSpace: 'nowrap' }}>Is Month Wise Report</label><br />
                    <label className="switch">
                        <input type="checkbox" checked={data.isMonthWise} onChange={e => updateData('isMonthWise', e.target.checked)} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div className="col" style={(data.isMonthWise == 0) ? { display: "" } : { display: "none" }}>
                    <label>Start Date</label>
                    <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                </div>
                <div className="col" style={(data.isMonthWise == 0) ? { display: "" } : { display: "none" }}>
                    <label>End Date</label>
                    <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                </div>
                <div className="col" style={(data.isMonthWise == 1) ? { display: "" } : { display: "none" }}>
                    <label>Year</label>
                    <select type="date" className="form-select" value={data.Year} onChange={(e) => updateData('Year', e.target.value)}>
                        <option value={year}>{year}</option>
                        <option value={year - 1}>{year - 1}</option>
                        <option value={year - 2}>{year - 2}</option>
                    </select>
                </div>
                <div className="col" style={(data.isMonthWise == 1) ? { display: "" } : { display: "none" }}>
                    <label>Month</label>
                    <select type="date" className="form-select" value={data.Month} onChange={(e) => updateData('Month', e.target.value)}>
                        <option value={1}>January</option>
                        <option value={2}>February</option>
                        <option value={3}>March</option>
                        <option value={4}>April</option>
                        <option value={5}>May</option>
                        <option value={6}>June</option>
                        <option value={7}>July</option>
                        <option value={8}>August</option>
                        <option value={9}>September</option>
                        <option value={10}>October</option>
                        <option value={11}>November</option>
                        <option value={12}>December</option>
                    </select>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem', display : 'flex', placeSelf: 'self-end' }} onClick={onSearch}>
                        {loading ? <img src={Loader} height="30" /> : 'Search'}
                    </button>
                </div>
            </div>
            {
                grid && grid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div style={{ textAlign: 'right' }}>
                            {/* <ExportExcelCSR data={grid} /> */}
                         <ExportExcelButton data={grid} 
                          columns={csrColumns} 
                          fileName="CustomerSummaryReport"/>

                        </div>
                        <br />
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Region</th>
                                        <th>Zone</th>
                                        <th>Branch</th>
                                        <th>Customer Name</th>
                                        <th>Account No</th>
                                        <th>Location Name</th>
                                        <th>Total Booked</th>
                                        <th>Booked</th>
                                        <th>Void</th>
                                        <th>Loadsheet</th>
                                        <th>Handed over to M&P</th>
                                        <th>Delivered</th>
                                        <th>RTS</th>
                                        <th>Undelivered</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        grid.map((x, index) =>
                                            <Fragment key={index}>
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{x.Region}</td>
                                                    <td>{x.Zone}</td>
                                                    <td>{x.Branch}</td>
                                                    <td>{x.CustomerName}</td>
                                                    <td>{x.AccountNo}</td>
                                                    <td style={{ minWidth: 200 }}>{x.LocationName}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('totalbooked', x.AccountNo, x.LocationID)}>{x.TotalBooked}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('booked', x.AccountNo, x.LocationID)}>{x.Booked}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('void', x.AccountNo, x.LocationID)}>{x.Void}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('loadsheet', x.AccountNo, x.LocationID)}>{x.Loadsheet}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('received', x.AccountNo, x.LocationID)}>{x.RecievedatOPS}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('delivered', x.AccountNo, x.LocationID)}>{x.Delivered}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('rts', x.AccountNo, x.LocationID)}>{x.RTS}</td>
                                                    <td style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => SearchDetail('undelivered', x.AccountNo, x.LocationID)}>{x.Undelivered}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={16} className="dtablecell">
                                                        {detailGrid.length > 0 &&
                                                            <div>
                                                                <br />
                                                                <h4 className="text-bold"> Details</h4>
                                                                <br />
                                                                {
                                                                    <div style={{ textAlign: 'left' }}>
                                                                        {/* <ExportExcelCSRDetail data={detailGrid} /> */}
                                                                          <ExportExcelButton data={detailGrid} 
                                                                            columns={csrDetailColumns} 
                                                                            fileName="CustomerDetailSummaryReport"/>  
                                                                    </div>
                                                                }<br />
                                                                <div className="table-responsive new-table-mnp">
                                                                    <table className="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>S.No</th>
                                                                                <th>Consignment Number</th>
                                                                                <th>Customer Name</th>
                                                                                <th>Account No</th>
                                                                                <th>Location Name</th>
                                                                                <th>Consignee</th>
                                                                                <th>Booking Date</th>
                                                                                <th>Origin Zone</th>
                                                                                <th>Origin Branch</th>
                                                                                <th>Dest Zone</th>
                                                                                <th>Dest Branch</th>
                                                                                <th>Pieces</th>
                                                                                <th>Weight</th>
                                                                                <th>COD Amount</th>
                                                                                <th>Order Ref No</th>
                                                                                <th>VOID</th>
                                                                                <th>Loadsheet</th>
                                                                                <th>Received</th>
                                                                                <th>Delivered</th>
                                                                                <th>RTS</th>
                                                                                <th>Undelivered</th>
                                                                                <th>Remarks</th>
                                                                                <th>Product Description</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                detailGrid.map((x, index) =>
                                                                                    <Fragment key={index}>
                                                                                        <tr key={index}>
                                                                                            <td>{index + 1}</td>
                                                                                            <td>{x.consignmentNumber}</td>
                                                                                            <td>{x.CustomerName}</td>
                                                                                            <td>{x.AccountNo}</td>
                                                                                            <td style={{ minWidth: 200 }}>{x.LocationName}</td>
                                                                                            <td>{x.consignee}</td>
                                                                                            <td>{new Intl.DateTimeFormat("en-GB", {
                                                                                                year: "numeric",
                                                                                                month: "short",
                                                                                                day: "2-digit"
                                                                                            }).format(new Date(x.BookingDate))}</td>
                                                                                            <td>{x.OriginZone}</td>
                                                                                            <td>{x.OriginBranch}</td>
                                                                                            <td>{x.DestZone}</td>
                                                                                            <td>{x.DestBranch}</td>
                                                                                            <td>{x.pieces}</td>
                                                                                            <td>{x.weight}</td>
                                                                                            <td>{x.codAmount}</td>
                                                                                            <td>{x.orderRefNo}</td>
                                                                                            <td>{x.VOID}</td>
                                                                                            <td>{x.Loadsheet}</td>
                                                                                            <td>{x.Received}</td>
                                                                                            <td>{x.Delivered}</td>
                                                                                            <td>{x.RTS}</td>
                                                                                            <td>{x.Undelivered}</td>
                                                                                            <td>{x.Remarks}</td>
                                                                                            <td>{x.productDescription}</td>
                                                                                        </tr>
                                                                                    </Fragment>
                                                                                )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        }</td>
                                                </tr>
                                            </Fragment>
                                        )
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            }
        </div>
    </section>
}

export default CustomerSummary;